module.exports = __webpack_public_path__ + "static/media/light-twitter-icon.13745d08.svg";